import { get } from '../../base';

import { MerchantGetManyProductsPayload, MerchantGetManyProductsResponse } from './types-get-many';

export function getManyMerchantProducts(
  params: MerchantGetManyProductsPayload
): Promise<MerchantGetManyProductsResponse> {
  return get('v5/merchant/products', { searchParams: params }).json();
}
